<script lang="ts">
    import { get } from 'svelte/store';
    import Switch from '../Switch.svelte';
    import { features, fm } from './features';

    function replaceAllNumberWithLink(text: string): string {
        // Replace all occurrences of # followed by 4 digits with a link
        // let output = text.replace(/#(\d\d\d\d+)/g, (match, number) => getBacklogLink(parseInt(number)));
        // make links for all urls
        let output = text.replace(
            /(https?:\/\/[^\s]+)/g,
            match => `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`
        );
        return output;
    }
</script>

<div style="display: flex; row-gap: 3px; flex-direction: column; font-size: inherit;">
    {#each Object.keys(get(fm).getFeatures()) as featureId}
        <Switch
            disabled={$fm.isDisabled(featureId)}
            checked={$fm.isEnabled(featureId)}
            label={replaceAllNumberWithLink($fm.getDescription(featureId))}
            on:change={e => {
                console.log('onChange', e);
                $fm.setEnabled(featureId, e.detail.checked);
                $fm = $fm;
                features.set($fm.getFeatures());
            }}
        />
    {/each}
</div>
